<template>
  <div class='parent'>
    <div class='content'>
        <div class='header'>
          <div class='logo'><img id='logo' src='./assets/images/logo.png'/></div>
          <div><p>- 易闪达，让传达更高效 -</p></div>
          <div><img src='./assets/images/lines.png'/></div>
        </div>
        <div class="method_1">
          <div>
              <img src='./assets/images/method1.png' />
          </div>
          <div class='empty'></div>
          <div class='number_1'>
              <div><img src='./assets/images/number1.png' /></div>
              <div><img src='./assets/images/number2.png' /></div>
              <div><img src='./assets/images/number3.png' /></div>
          </div>
          <div class='empty'></div>
          <div class='line_1'>
              <div>
                <img class='type_1' src='./assets/images/search1.png' />
                <p>微信中搜索“易闪达”</p>
              </div>
              <div>
                <img class='type_1' src='./assets/images/search2.png' />
                <p>点击搜一搜</p>
              </div>
              <div>
                <img class='type_1' src='./assets/images/search3.png' />
                <p>找到易闪达小程序</p>
              </div>
          </div>
      </div>
      <div class="method_2">
          <div>
              <img src='./assets/images/method2.png' />
          </div>
          <div class='number_2'>
              <div><img src='./assets/images/number1.png' /></div>
              <div><img src='./assets/images/number2.png' /></div>
              <div><img src='./assets/images/number3.png' /></div>
          </div>
          <div class='line_2'>
              <div>
                <img class='type_1' src='./assets/images/code1.png' />
                <p>长按上方二维码保存图片到相册</p>
                </div>
              <div>
                <img class='type_1' src='./assets/images/code2.png' />
                <p>在微信首页点击“+”打开扫一扫</p>
                </div>
              <div>
                <img class='type_1' src='./assets/images/code3.png'/>
                <p>相册选取图片-完成</p>
                </div>
          </div>
      </div>
      <div class='footer'>
          <p>{{company}}</p>
          <p>地址:{{address}}</p>
          <span>电话:</span><a :href="'tel:'+phone" class="call">{{phone}}</a>
          <p>闽ICP备15003756号-2</p>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  data () {
    return {
        address:'福建省福州市鼓楼区软件大道89号福州软件园F区5号楼22层',
        company:'福州鑫博雅信息技术有限公司',
        phone:'0591-87511030',
        size:'3x'
    }
  }
  
}

</script>

<style>
  .content{
    /* display: inline-block; */
    padding:18pt;
    /* width:1000px; */
    /* text-align:center; */
    /* vertical-align:middle; */
  }
  .header,.footer,.number_1,.line_1,.number_2,.line_2{
    text-align:center
  }
  .header div:nth-child(2){
    font-size: 22pt
  }
  div.logo{
    /* margin:37pt 140pt 0pt 147pt */
    margin-top: 36pt;
  }
  .header div:nth-child(3){
    margin:13pt 0pt 49pt 0pt
  }
  .method_1 div:nth-child(1),.method_2 div:nth-child(1){
    margin-bottom: 15pt;
  }
  .method_1 div:nth-child(1) img{
    /* text-align: left; */
  }
  .number_1,.number_2{
    border-bottom: 2pt dashed #2399FA;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
     margin-bottom: 16pt;
  }
  .number_1 > div,.number_2 > div{
    height: 7px;
  }
  .number_1 > div,.number_2 > div{
    width: 33.3%;
  }
  .line_1,.line_2{
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    font-size: 26pt;
  }
  .line_1 div,.line_2 div{
    width: 33%;
  }
  .line_1 p,.line_2 p{
    margin-top: 5pt;
    margin-bottom: 15pt
  }
  .line_1{
    margin-bottom: 24pt;
  }
  .footer{
    margin-top: 48pt;
    color:#999999;
    font-size: 20pt;
    /* position: absolute; */
    left: 0;
    right: 0;
    bottom: 20px;
    /* margin: auto; */
  }
  .footer p{
   margin-top: 5pt;
   margin-bottom: 5pt;
  }
  .phone{
    color: #2399FA;
  }
  /* .empty{
    height: 40px;
  } */

</style>



// WEBPACK FOOTER //
// src/App.vue